module.exports = __webpack_public_path__ + "static/img/HK.562f2c5.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/HK.png
// module id = t6e8
// module chunks = 1